module.exports = __webpack_public_path__ + "img/logo-psa.402c7da4.jpg";